import { StoreDownloadSection } from './StoreDownloadSection';
import { InteractionSection } from './InteractionSection';
import { ThumbnailSection } from './ThumbnailSection';

export const Home = {
  ...StoreDownloadSection,
  ...InteractionSection,
  ...ThumbnailSection,
};
